import { dark } from './semantics/dark';
import { light } from './semantics/light';

const tokens = { dark, light };

export default tokens;
